/**
 * Created by luka on 23.02.2018.
 */
import {post} from "../utils/api";
import {clearUser, getUser, saveUser} from "../utils/auth";
import {LOADING_LOGIN_FAILED, LOGIN, LOGIN_FETCH_DATA_SUCCESS, LOGIN_LOADING, LOGOUT} from "../actions/types";
import {LOGIN_SUCCESSFUL} from "../utils/constants";
import {resetNavigationToOverview} from "../navigation/NavigationActions";

export function loadingLoginFailed(error) {
    return {
        type: LOADING_LOGIN_FAILED,
        error
    };
}

export function loginIsLoading(bool) {
    return {
        type: LOGIN_LOADING,
        isLoading: bool
    };
}

export function loginFetchDataSuccess(login) {
    return {
        type: LOGIN_FETCH_DATA_SUCCESS,
        login
    };
}

export function userLoggedIn(user) {
    return {
        type: LOGIN,
        user: user,
        isLoggedIn: true
    };
}

export function userLoggedOut() {
    return {
        type: LOGOUT,
        isLoggedIn: false
    };
}

export function logout() {
    return (dispatch) => {
        clearUser();
        dispatch(userLoggedOut());
    }
}

export function autoLoginIfUserSaved() {
    return (dispatch) => {
        //dispatch(loginIsLoading(null, true));

        getUser()
        //.then(sleeper(2000)) //just delay for testing
            .then(user => {
                if(user){
                    dispatch(userLoggedIn(user));
                    //dispatch(resetNavigationToOverview());
                }else{
                    dispatch(userLoggedOut());
                   // dispatch(resetNavigationToLogin());
                }
            })
            .catch(err => userLoggedOut());
    }
}

export function loginFetchData(email, password, accesshash) {
    return (dispatch) => {
        dispatch(loginIsLoading(true));

        post('login', {
            email: email,
            password: password,
            accesshash: accesshash
        })

            .then((login) => {
                if (login.msg === LOGIN_SUCCESSFUL) {
                    saveUser(login.user);

                    dispatch(userLoggedIn(login.user));
                    dispatch(resetNavigationToOverview());
                }

                dispatch(loginFetchDataSuccess(login));
                dispatch(loginIsLoading(false));
            })
            .catch((error) => {
                dispatch(loadingLoginFailed(error));
                dispatch(userLoggedOut());
                dispatch(loginIsLoading(false));
            });
    };
}


// WEBPACK FOOTER //
// ./src/login/LoginAction.js